import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import { Preloader } from '../';
import { UsersService } from '../../services/user';
import './sso.css';

export default class SSO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    this.handleSSO();
  }

  async handleSSO() {
    const { organization, login, token } = this.props.match.params;
    const queryParams = new URLSearchParams(this.props.location.search);
    let path = queryParams.get("path") || "";

    // Converter paths antigos para novos
    if (path.startsWith("/edition/")) {
      const isbn = path.replace("/edition/", "");
      // path = `/search/metadata?q=${isbn}`;
      path = `/search/term/1/${isbn}`
    } else if (path === "") {
      path = "/";
    }

    try {
      if (organization && login && token) {
        await this.authenticateSSO({ login, organization, token, path });
      }
    } catch (error) {
      console.error('Erro no SSO:', error);
      this.redirectToLogin();
    }
  }

  async clearAllAuthData() {
    console.log('Limpando dados de autenticação...');
    
    try {
      await UsersService.signOut();
      
      // Forçar limpeza completa do SDK
      if (window.Sdk && window.Sdk.Api && window.Sdk.Api.authorization) {
        window.Sdk.Api.authorization.credential = null;
        window.Sdk.Api.authorization.user = null;
        window.Sdk.Api.authorization.activeProject = null;
        delete window.Sdk.Api.authorization.credential;
        delete window.Sdk.Api.authorization.user;
        delete window.Sdk.Api.authorization.activeProject;
      }
      
      // Limpar headers de autorização se existirem
      if (window.Sdk && window.Sdk.Api && window.Sdk.Api.headers) {
        delete window.Sdk.Api.headers.Authorization;
        delete window.Sdk.Api.headers.authorization;
      }
      
      // Disparar evento de logout
      window.dispatchEvent(new Event("@rdpplayer.event(logout)"));
      
    } catch (e) {
      console.log('Erro ao fazer signOut:', e);
    }
    
    console.log('Limpeza concluída');
  }

  async authenticateSSO({ login, organization, token, path }) {
    try {

      // Limpar sessão ANTES da chamada SSO
      await this.clearAllAuthData();

      // Buscar o connector correto
      if(!Sdk.Api.authorization.activeProject)
      {
        await this.setActiveProject();
      }

      const connectors = Sdk.Api.authorization.activeProject?.connectors;
      const connector = connectors?.find(item => 
        item.iternal_name === "LibraryMigration" || item.name === "SenacMigration"
      );

      if (!connector) {
        throw new Error('Connector não encontrado');
      }      

      const route = `/cms/v1.1/bridge/connector/uid/${connector.uid}/sso?login=${login}&organization_id=${organization}&token=${token}`;
      const url = `${Sdk.Api.domain}${route}`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Api-Env': Sdk.Api.enviroment,
          'Project-Key': Sdk.Api.projectKey
        }
      });
      
      if (!response.ok) {
        throw new Error(`Erro na requisição SSO: ${response.status}`);
      }
      
      const result = await response.json();
      
      await Sdk.Api.authorization.signinByCredential(result);
      const user = await Sdk.Api.authorization.userInfo();

      debugger;
      UsersService.setUser(JSON.stringify(user));

      // console.log(Sdk.Api.authorization.activeProject);

      // Redirecionar para o path especificado
      window.location.hash = path;
    } catch (error) {
      console.error('Erro na autenticação SSO:', error);
      this.redirectToLogin();
    }
  }

  async setActiveProject() {
    try {
      const response = await fetch("./api_context.json");
      const config = await response.json();
      const projectUid = config.project_uid;

      var project = await Sdk.dynamic.bridge(`auth/v1.0/project/uid/${projectUid}`, null, 'GET');
      
      // console.log('Projeto ativo definido:', project);
      // await Sdk.authorization.setActiveProject(project); 
      await Sdk.Api.initializeFromProject(config.project_uid, "Insights_1", "Insights_1");
  
    } catch (e) {
      console.error(e)
    }
  }

  redirectToLogin() {
    window.location.hash = '/login';
  }

  render() {
    return (
      <div className="rdp-react-template-view-sso">
        <Preloader show={this.state.loading} />
      </div>
    );
  }
}
